export const GREY = '#C3C8CC'
export const CHARCOAL_BLACK = '#202227'
export const BLACK_RUSSIAN = '#26272B'
export const GREEN = '#26c5a8'
export const MADISON_BLUE = '#082b5f'
export const CORAL_RED = '#f98a83'
export const YELLOW = '#f1c40f'
export const RED = '#e74c3c'
export const PURPLE = '#9b59b6'
export const STEPPER_GREEN = '#26C4A8'
export const GRASS_GREEN = '#2BB673'
export const STEPPER_GREY = '#E7E7E7'
export const WHITE = '#fff'
export const BORDER_BLUE = '#092B5F'
export const MEDIUM_BLACK = '#26272A'
export const BLACK_PEARL = '#171C21'
export const LIGHT_PINK = 'rgba(249, 138, 130, 0.1)'
export const TRANSPARENT = 'rgba(0,0,0,0)'
export const SPUN_PEARL = '#ACACAE'
export const LAVENDAR = '#E8EDF8'
export const COD_GREY = '#1d1d1d'
export const SLATE_GRAY = '#707C8D'
export const SILVER = '#CCCCCC'
export const CADET_GREY = '#9CA6B2'
export const GOLD = '#FAA61A'
export const SEARCH_GREY = '#707C8D'
export const CINDER = '#212529'
export const LIGHT_GREY = '#dadada'
export const DODGER_BLUE = '#0d85f4'
export const OSLO_GREY = '#8d8f93'
export const DANDELION = '#ffd964'
export const GHOST_WHITE = '#F7F9FB'
export const LATTE = '#F1EADD'
export const NAVY = '#14467C'
export const DIM_GREY = '#666666'
export const BRIGHT_BLUE = '#0379BF'
export const BLACK = '#000000'
export const SILVER_SAND = '#BDBDBA'
export const MEDIUM_GREY = '#818181'
export const SUNRISE_50 = '#FFF2D6'
export const PALE_GRAY = '#E2E2E2'
export const PlACEBO_SKY = '#E5F7FB'
export const ALICE_BLUE = '#f1f4f7'
export const SUMMER_SKY = '#189adf'
export const LATTE_50 = '#F8F5EE'
